import React, { FC } from "react"
import { Spacer } from "../atoms/Atoms"
import { CenteredLayout } from "../atoms/Layouts"
import InformationModal from "./InformationModal"
import FLEInformationModalMarkdown from "./FLEInformationModalMarkdown"
import { CloseButton } from "../atoms/buttons/CloseButton"
import { BenefitConfiguration } from "types/benefitConfiguration"
import { H2 } from "@carrotfertility/carotene"

type FLEInformationModalProps = {
  header: string
  source: string
  onClose: () => void
  showInDesktopView?: boolean
  isTCPPModal?: boolean
  benefitConfiguration: BenefitConfiguration
}

const FLEInformationModal: FC<FLEInformationModalProps> = ({
  header,
  source,
  onClose,
  showInDesktopView,
  isTCPPModal
}) => {
  const makeRelative = isTCPPModal ? "relative" : null

  return (
    <InformationModal titleText={header} onExit={onClose}>
      <CenteredLayout>
        <div className={makeRelative + " mw6"}>
          <H2 variant="dark">{header}</H2>
          <Spacer height={1} />
          <FLEInformationModalMarkdown source={source} />
          <CloseButton onClose={onClose} showInDesktopView={showInDesktopView} />
        </div>
      </CenteredLayout>
    </InformationModal>
  )
}

export default FLEInformationModal
